<template>
    <div class="d-flex flex-column gap-4">
        <base-input-floating
            :label="$t('widgets.ranking.preTitle')"
            :formErrors="errors"
            :rules="{required: false, max: 255}"
            name="preTitleRanking"
            v-model="widget.content.preTitle"/>

        <base-input-floating
            :label="$t('widgets.ranking.mainTitle')"
            :formErrors="errors"
            :rules="{required: false, max: 255}"
            name="mainTitleRanking"
            v-model="widget.content.mainTitle" />

        <WidgetIntervalSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <base-input-floating
            v-if="widget?.content"
            :rules="{required: true, min_value:1}"
            :formErrors="errors"
            type="number"
            :min="1"
            :is-disabled="widget?.content.userSelect === 'authenticated'"
            :label="$t('widgets.startPosition.title')"
            name="startPosition"
            v-model="widget.content.startPosition"
            @change="getWidgetData()" />

        <WidgetLimitEntries
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <div class="border-bottom"></div>

        <WidgetUserSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <div class="border-bottom"></div>

        <WidgetEventTypeSelect
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            @update:data="getWidgetData()"/>

        <div class="border-bottom"></div>

        <WidgetDataDisplayOption
            v-model="widget"
            :errors="errors"
            :organisationId="organisationId"
            :options="['sum', 'amount', 'topEvent']"
            @update:data="getWidgetData()"/>
    </div>
</template>

<script setup>
import {useDashboardStore} from '~/store/dashboard';
import {getData} from "~/composables/widget";
import BaseInputFloating from "~/components/farbcode-core/Inputs/BaseInputFloating.vue";
import WidgetUserSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetUserSelect";
import WidgetEventTypeSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetEventTypeSelect";
import WidgetDataDisplayOption from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetDataDisplayOption";
import WidgetIntervalSelect from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetIntervalSelect";
import WidgetLimitEntries from "~/components/pages/dashboards/widgets/WidgetSettings/WidgetLimitEntries";

const dashboardStore = useDashboardStore()
const {t} = useI18n()

const props = defineProps({
    nodeId: {
        required: true,
        type: Number,
    },
    errors: {
        required: false,
        type: Object,
        default: {}
    },
    modelValue: {
        required: true,
        type: Object,
    },
    organisationId: {
        required: true,
        type: [Number, null],
    }
})

const emit = defineEmits(['update:modelValue'])

const widget = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})

function getWidgetData() {
    checkIfAuthUserSelected()
    getData(props.nodeId, dashboardStore.dashboard.token, 'ranking')
}

function checkIfAuthUserSelected() {
    if (widget.value.content.userSelect === 'authenticated') {
        widget.value.content.startPosition = 1
    }
}
</script>

